import { render, staticRenderFns } from "./EventDocsUpload.modal.vue?vue&type=template&id=cbf6c166&scoped=true"
import script from "./EventDocsUpload.modal.vue?vue&type=script&lang=js"
export * from "./EventDocsUpload.modal.vue?vue&type=script&lang=js"
import style0 from "./EventDocsUpload.modal.vue?vue&type=style&index=0&id=cbf6c166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf6c166",
  null
  
)

export default component.exports